<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-15 18:42:05
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="Browser_title">{{ $t("wifi.txt1") }}</div>
    <table class="mytable">
      <tr>
        <th>{{ $t("wifi.txt2") }}</th>
        <th>{{ $t("wifi.txt3") }}</th>
        <th>{{ $t("wifi.txt4") }}</th>
        <th>{{ $t("wifi.txt5") }}</th>
        <th>{{ $t("wifi.txt6") }}</th>
        <th style="width: 140px">{{ $t("wifi.txt7") }}</th>
      </tr>
      <tr v-for="(val, key) in list" :key="key">
        <td>{{ val.ssid }}</td>
        <td>{{ val.name }}</td>
        <td>{{ val.time_show }}</td>
        <td>{{ val.latitude }}</td>
        <td>{{ val.longitude }}</td>
        <td style="width: 140px">
          <div
            @click="addlist(val.id, val.is_block)"
            :class="val.is_block == 0 ? 'Block' : 'Block'"
          >
            {{ val.is_block == 0 ? $t("Block") : $t("Unblock") }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getWifiNotSame, WifiAddBlock } from "@/api/user";

export default {
  name: "HelloWorld",
  data() {
    return {
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 9999,
        starttime: "2000-01-01",
        endtime: "3000-01-01",
      },
      list: [],
      msg: "",
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist() {
      getWifiNotSame(this.key).then((adj) => {
        this.list = adj.data.list;
      });
    },
    addlist(a, b) {
      return;
      // eslint-disable-next-line no-unreachable
      var key = {
        equipment_id: localStorage.getItem("systemId"),
        wifi_id: a,
        block: (b + 1) % 2,
      };
      WifiAddBlock(key).then((qwe) => {
        this.webUrl = "";
        this.getlist();
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.Browser_title {
  line-height: 55px;
  padding-top: 10px;
  height: 55px;
  text-indent: 2.5%;
  font-weight: 700;
  border-bottom: 1px solid #e1e3e6;
  font-size: 14px;
  color: #000927;
}
</style>



// WEBPACK FOOTER //
// src/components/WiFi.vue